export default __webpack_public_path__ + "static/gluten-free-19c0263d938efcf6cb4a2a0a031ebf64.svg";